export default {
  zh: {
    继续闯关: '继续闯关',
    休息一下: '休息一下',
    我要退出: '我要退出',
    重新开始: '重新开始',
    通关详情: '通关详情',
    再来一次: '再来一次',
    闯下一关: '闯下一关',
    我的录音: '我的心法',
    开始闯关: 'Action',
    查看报告: '查看报告',
    闯关提示: '闯关提示',
    通知: '通知',
    切换清晰度: '切换清晰度',
    我知道了: '我知道了',
    重新提交: '重新提交',
    去闯关: '去闯关',
    取消: '取消',
    进入指导会: '进入指导会',
    确定: '确定',
    提交: '提交',
    上一题: '上一题',
    下一题: '下一题',
    返回: '返回',
  },
  en: {
    继续闯关: 'Go on',
    休息一下: 'Take a break',
    我要退出: 'Quit',
    重新开始: 'Restart',
    通关详情: 'Test Details',
    再来一次: 'Review',
    闯下一关: 'The next lesson',
    我的录音: 'recording',
    开始闯关: 'Answer',
    查看报告: 'Report',
    闯关提示: 'Advice',
    通知: 'Notice',
    切换清晰度: 'Definition',
    我知道了: 'Got it',
    重新提交: 'Submit again',
    去闯关: 'Start',
    取消: 'Cancel',
    进入指导会: 'Enter',
    确定: 'OK',
    提交: 'Submit',
    上一题: 'Previous',
    下一题: 'Next',
    返回: 'Return',
  },
}
